import { BodyEmpty } from "./BodyEmpty";
export default BodyEmpty;
